import React, { Component, Suspense, lazy, Fragment } from 'react';
import { IAppProps } from './models/IAppProps';
import { IAppState } from './models/IAppState';
import { inject, observer } from 'mobx-react';
import Wrapper from './styledComponents/Wrapper';
import HeaderWrapper from './styledComponents/HeaderWrapper';
import RedirectButtonWrapper from './styledComponents/RedirectButtonWrapper';
import { InjectedStyledComponent } from '../shared/InjectedStyledComponent';
import Loading from '../shared/Loading';
import SkeletonLoader from '../shared/SkeletonLoader';
import Application from '@kurtosys/ksys-app-components/dist/components/base/Application';
import Carousel from '@kurtosys/ksys-app-components/dist/components/base/Carousel';
import FundCard from '../FundCard';
import Heading from '@kurtosys/ksys-app-components/dist/components/base/Heading';
import RedirectButton from '@kurtosys/ksys-app-components/dist/components/base/RedirectButton';

@inject('appStore', 'queryStore')
@observer
export class App extends Component<IAppProps, IAppState> {
	static configurationKey: 'app' = 'app';
	static styleKey: 'app' = 'app';
	constructor(props: IAppProps) {
		super(props);
	}
	render() {
		const { className, appStore, selector, queryStore } = this.props;
		if (!appStore || !queryStore) {
			return null;
		}
		const { isBootstrapped, skeletonLoader, skeletonLoaders } = appStore;
		if (!isBootstrapped) {
			if (skeletonLoader) {
				return <SkeletonLoader config={skeletonLoader} variables={skeletonLoaders && skeletonLoaders.variables} />;
			}
			return <Loading />;
		}
		const {
			theme,
			show,
			showPlaceholder,
			noDataPlaceholder,
			libraryComponentsConfiguration,
			getTranslateFunction,
			assets,
			assetCacheOptions,
			assetRegisters,
			fundCards,
			carouselProps,
			headingProps,
			globalRedirectButtonProps,
		} = appStore;

		if (!show) {
			return null;
		}

		const fundCardComponents = (fundCards || []).map((fundCardProps, index) => {
			return (
				<FundCard key={ `fundCard${ index }` } { ...fundCardProps } />
			);
		});

		const translate = getTranslateFunction();
		return (
			<Application
				theme={ theme }
				configuration={ libraryComponentsConfiguration }
				translate={ translate }
				assets={ assets }
				assetCacheOptions={ assetCacheOptions }
				assetRegisters={ assetRegisters }
			>
				<Wrapper className={ className }>
					{showPlaceholder && noDataPlaceholder}
					{ !showPlaceholder && (
						<Fragment>
							{ headingProps && (
								<HeaderWrapper>
									<Heading { ...headingProps } />
								</HeaderWrapper>
							) }
							{ carouselProps && (
								<Carousel { ...carouselProps }>
									{ fundCardComponents }
								</Carousel>
							) }
							{ !carouselProps && fundCardComponents }
							{ globalRedirectButtonProps && (
								<RedirectButtonWrapper>
									<RedirectButton { ...globalRedirectButtonProps } />
								</RedirectButtonWrapper>
							) }
						</Fragment>
					)}
				</Wrapper>
			</Application>
		);
	}
}

export default InjectedStyledComponent(App, 'app');
